export default __webpack_public_path__ + "static/media/webapplication.60d901c1.jpg";